<template>
  <div>
    <b-modal v-model="agreementModal" size="lg" ok-title="Continue" @ok="createSubscriptionPurchase" :ok-disabled="!acceptedTerms" title="Terms and Conditions">
      <div v-html="agreement" class="pb-3"></div>
      <b-form-checkbox v-model="acceptedTerms">
        I accept the Subscription Terms
      </b-form-checkbox>
    </b-modal>

    <form ref="form">
      <b-alert variant="danger" :show="error !== null" v-html="error"></b-alert>

      <b-row>
        <b-col>
          <b-form-group label="Billing contact person" label-class="text-truncate label-required">
            <b-input type="text" v-model="purchaseOrderName" required/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="6">
          <b-form-group label="Email address" label-class="text-truncate label-required">
            <b-input type="email" v-model="purchaseOrderEmail" required/>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group label="Phone number" label-class="text-truncate">
            <b-input type="text" v-model="purchaseOrderPhone"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label="Comments" label-class="text-truncate">
            <b-textarea v-model="purchaseOrderComments"/>
          </b-form-group>
        </b-col>
      </b-row>

      <agree-subscription :agreement="agreement"/>

      <div class="d-flex justify-content-center">
        <button
          class="btn btn-primary btn-rounded px-4 py-2 my-3"
          type="button"
          @click="createPurchase"
          :disabled="saving">
          <span v-if="saving">Please wait...</span>
          <span v-else>Send Request</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>

import PaymentCardForm from "../Payments/PaymentCardForm.vue";
import OrganizationBillingFormInputsSlim from "../Assets/OrganizationBillingFormInputsSlim.vue";
import {SubscriptionsApi} from "../../Api/SubscriptionsApi.js";
import GeneralMixins from "../../../mixins/GeneralMixins.js";
import {PaymentsApi} from "../../Api/PaymentsApi.js";
import AgreeSubscription from "./AgreeSubscription.vue";

export default {
  props: {
    agreement: {
      type: String,
      required: true
    },
    selectedPriceId: {
      type: String,
      required: true
    }
  },

  components: {AgreeSubscription, OrganizationBillingFormInputsSlim},
  mixins: [GeneralMixins],

  data() {
    return {
      saving: false,
      error: null,
      acceptedTerms: false,
      agreementModal: false,

      purchaseOrderName: null,
      purchaseOrderEmail: null,
      purchaseOrderPhone: null,
      purchaseOrderComments: null,
    };
  },

  methods: {
    validateLocalForm() {
      if (!this.$refs.form.reportValidity()) {
        this.saving = false
        return
      }

      if (this.purchaseOrderName.trim() === '') {
        this.error = 'Name is required.';
        this.saving = false
        return false;
      }

      if (this.purchaseOrderEmail.trim() === '') {
        this.error = 'Email is required.';
        this.saving = false
        return false;
      }

      return true
    },

    createPurchase() {
      if (!this.validateLocalForm()) {
        return;
      }

      this.agreementModal = true
    },

    async createSubscriptionPurchase() {
      if (!this.acceptedTerms) {
        this.showErrorToast("You must accept the subscription terms")
        return;
      }

      this.saving = true

      try {
        await SubscriptionsApi.createPurchaseOrderSubscription(this.subscriptionParams)
        this.saving = false
        this.$emit('success')
      } catch (error) {
        this.saving = false
        this.showErrorToast(this.getErrorMessages(error.body, true))
      }

    }
  },

  computed: {

    subscriptionParams() {
      return {
        price_id: this.selectedPriceId,
        purchase_order_data: {
          purchase_order_name: this.purchaseOrderName,
          purchase_order_email: this.purchaseOrderEmail,
          purchase_order_phone: this.purchaseOrderPhone,
          purchase_order_comments: this.purchaseOrderComments
        }
      }
    }
  }
}
</script>